<template>
  <div id="rating" class="container overflow-y" style="position: relative;">
    <NavBar :title="$t('general.rateYourExperience')" />
    <el-row class="rate-detail">
      <form id="ratingForm">
        <div class="rating-title">
          <h3>
            {{ $t('general.driverRaiting', { name: deliveryManName }) }}
          </h3>
        </div>
        <task-raiting
          :src="avatarDriver"
          :element-value="deliveryManName"
          :element-field="$t('general.driver')"
          :rate-value.sync="form.driverRate"
          :rate-field="$t('general.driverRate')"
          :disabled="disabledRate" />
        <div class="rating-title mt-60">
          <h3>
            {{ $t('general.experienceRaiting') }}
          </h3>
        </div>
        <task-raiting
          :src="shoppingImageUrl"
          :element-value="branchName"
          :element-field="$t('general.branch')"
          :rate-value.sync="form.orderRate"
          :rate-field="$t('general.branchRate')"
          :border-radius="borderRadius"
          :background-color="backgroundColor"
          :disabled="disabledRate" />
        <el-row class="mt-60 mb-30">
          <el-input
            v-model="form.comment"
            :disabled="disabledRate"
            :placeholder="$t('messages.addComment')"
            type="textarea"
            maxlength="140"
            rows="4" />
        </el-row>
        <el-button
          :disabled="disabledButton"
          type="primary"
          native-type="submit"
          form="ratingForm"
          class="btn-interface red btn-floating custom-btn detail-button-mobile"
          @click.native.prevent="sendRate">
          {{ $t('general.finish') }}
        </el-button>
      </form>
    </el-row>
    <el-button
      :disabled="disabledButton"
      type="primary"
      native-type="submit"
      form="ratingForm"
      class="btn-interface red btn-floating custom-btn detail-button"
      @click.native.prevent="sendRate">
      {{ $t('general.finish') }}
    </el-button>
    <Footer />
  </div>
</template>
<script>
// Utils
import { mapGetters } from 'vuex'
import status from '@/utils/status'
import { getFolio, sendRate } from '@/api/customer'
import CONSTANTS from '@/utils/const'

// Components
import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'
import TaskRaiting from '@/components/TaskRaiting'

export default {
  name: 'TaskRating',
  components: {
    NavBar,
    Footer,
    TaskRaiting
  },
  data: function() {
    return {
      shoppingImageUrl: '/img/logo.png',
      form: {
        orderRate: 0,
        driverRate: 0,
        comment: ''
      },
      borderRadius: '0%',
      backgroundColor: 'transparent'
    }
  },
  computed: {
    ...mapGetters(['order']),
    disabledButton: function() {
      return (this.form.orderRate === 0 || this.form.driverRate === 0 && typeof this.form.comment !== 'string') || this.disabledRate
    },
    disabledRate: function() {
      return typeof this.order.rates !== 'undefined'
    },
    deliveryManName: function() {
      let name = this.order.deliveryMan.name.toLowerCase()
      name = name.charAt(0).toUpperCase() + name.slice(1)
      return name
    },
    branchName: function() {
      return this.order.build.name.toLowerCase()
    },
    avatarDriver: function() {
      return (this.order.deliveryMan && this.order.deliveryMan.photo) ? this.order.deliveryMan.photo : CONSTANTS.AVATAR.DRIVER
    }
  },
  mounted() {
    this.goToCompletedScreen()
    if (this.disabledRate) {
      this.form = {
        orderRate: this.order.rates.orderRate,
        driverRate: this.order.rates.driverRate,
        comment: this.order.rates.orderComment
      }
    }
  },
  methods: {
    goToCompletedScreen: function() {
      this.$router.push({ path: '/complete', query: this.$route.query })
    },
    inTransit: function() {
      return status.transit.includes(this.order.orderStep)
    },
    completed: function() {
      return status.object.COMPLETED === this.order.orderStep
    },
    reloadTask: async function() {
      this.$store.commit('SET_ORDER', await getFolio(this.order.folio))
    },
    sendRate: function() {
      sendRate({
        ...this.form
      }, this.order.folio).then(res => {
        this.$router.push({ path: '/complete', query: this.$route.query })
      })
    }
  }
}
</script>
<style>
.rating-title {
  margin-bottom: 20px !important;
}
.rating-title h3 {
  font-size: 20px;
  color: #737373;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1875px;
  margin: 0 !important;
  text-align: center;
}
</style>
